import {Game} from "@game/game";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {AvatarIcon} from "@components/interface/AvatarIcon";
import {CSSProperties, useEffect, useState} from "react";
import {GameEvent} from "@game/gameEvent";
import {connect} from "react-redux";
import {update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";
import {MAP_BORDER_INSET} from "@components/map/MapBorder";

const styles: Record<string, CSSProperties> = {
    content: {
        display: "flex",
        position: "fixed",
        right: 0,
        top: 0
    },
    menu: {
        backgroundColor: "#f5f0e8",
        border: "1px solid #c8b89a",
        borderRadius: 4,
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        color: "#2d5a1b",
        cursor: "pointer",
        fontWeight: "bold",
        height: 20,
        marginTop: 4,
        marginRight: 4,
        padding: 4,
        textAlign: "center",
        width: 20
    },
    row: {
        display: "flex",
        justifyContent: "flex-end"
    },
    score: {
        display: "flex",
        flexDirection: "column"
    },
    section: {
        backgroundColor: "#f5f0e8",
        border: "1px solid #c8b89a",
        borderRadius: 4,
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        height: 20,
        marginTop: 4,
        marginRight: 4,
        padding: 4
    },
    text: {
        color: "#2d5a1b",
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        fontSize: "large",
        fontWeight: "bold",
    },
    words: {
        display: "flex",
        flexDirection: "column"
    }
};

interface IPlacedWord {
    score: number
    word: string
}
interface ITopBar {
    game: Game
    updateDialog: Update
}
function TopBar({game, updateDialog}: ITopBar) {
    const [score, setScore] = useState(0);
    const [words, setWords] = useState<IPlacedWord[]>([]);
    const handleMenuClick = () => {
        updateDialog({update: {name: "game"}});
    };
    const handleScoreClick = () => {
        updateDialog({update: {name: "score"}});
    };
    const handleLeagueClick = () => {
        updateDialog({update: {name: "league"}});
    };
    const contentStyle = {
        ...styles.content,
        right: MAP_BORDER_INSET + 4,
        top: MAP_BORDER_INSET + 4
    }

    useEffect(() => {
        const updateWords = (words: IPlacedWord[]) => {
            setWords(words);
            if (words.length) {
                setTimeout(() => {
                    setScore(score => score + words[0].score);
                    updateWords(words.slice(1));
                }, 1000);
            }
        }
        const handleEvent = (event: GameEvent) => {
            if (event.type === "PlayerScored") {
                updateWords(event.properties.words || []);
            } else if (event.type === "UserPlayerInitialised") {
                setScore(game.userPlayer!.score.lifetime)
            }
        }

        setScore(game.userPlayer?.score.lifetime ?? 0);
        game.events.delegates.add(handleEvent);
        return () => game.events.delegates.remove(handleEvent);
    }, [game]);
    if (game.userPlayer === undefined) return null;
    return (
        <div style={contentStyle}>
            <div style={styles.score}>
                <div style={styles.row}>
                    <div onClick={handleLeagueClick} style={{...styles.section, cursor: "pointer"}}>
                        <LocalisedTypography content="League" style={styles.text}/>
                    </div>
                    <div onClick={handleScoreClick} style={{...styles.section, cursor: "pointer"}}>
                        <LocalisedTypography content={score.toString()} style={styles.text}/>
                    </div>
                </div>
                <div style={styles.words}>
                    {words.map((word, index) =>
                        <div key={index} style={styles.row}>
                            <div style={styles.section}>
                                <LocalisedTypography content={word.word} style={styles.text}/>
                            </div>
                            <div style={styles.section}>
                                <LocalisedTypography content={word.score.toString()} style={styles.text}/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div onClick={handleMenuClick} style={styles.menu}>
                <AvatarIcon style={{width: "100%", height: "100%", color: "#2d5a1b"}}/>
            </div>
        </div>
    );
}
const mapStateToProps = (_: never) => ({
});
const connected = connect(mapStateToProps, {
    updateDialog
})(TopBar);
export {connected as TopBar}
